package com.esoris.esocomponent.ui.defaultvalue

import androidx.compose.ui.unit.dp

object EsoPadding {
    val small = 4.dp
    val medium = 8.dp
    val large = 16.dp
    val xLarge = 24.dp
}